document.addEventListener('click', function (e) {
  const a = e.target.closest('a[href="#"]');
  if (!a) return;

  // Evita el salto a la parte superior de la página
  e.preventDefault();

  // Busca el contenedor del item de menú y alterna la clase que abre el submenú
  const li = a.closest('li');
  if (!li) return;

  // Motion suele usar atributos/clases para expandir; probamos ambas:
  li.classList.toggle('is-open');
  if (a.hasAttribute('aria-expanded')) {
    a.setAttribute('aria-expanded', a.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  }
});
